import { Page } from '@/core/architecture'

import { StoreCollectionsSelectTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreCollectionsSelect Page
 * Implemented as a practical sample.
 */
export const StoreCollectionsSelect: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreCollectionsSelectTemplate state={state} {...actions} />
}
